import { observer } from "mobx-react-lite";
import { MDSButton, MDSButtonSize, MDSButtonVariant } from "@/mds";
import { useAppStore } from "@/store";

export const DelegateButton = observer(({ onPress }: { onPress: () => void }) => {
  const { store } = useAppStore();
  if (store.spaceAccountFeatureFlags.getFlagStatus("mem-agent-task-delegation") !== true)
    return null;
  return (
    <span onClick={event => event.stopPropagation()}>
      <MDSButton
        size={MDSButtonSize.Small}
        variant={MDSButtonVariant.Transparent}
        onPress={onPress}
      >
        Delegate
      </MDSButton>
    </span>
  );
});
